<template>
  <el-card>
    <level-form readonly :data="detailInfo" />
  </el-card>
</template>

<script>
import LevelForm from "@/components/member-level/LevelForm";
import {request} from "@/config/request";
export default {
  name: "MemberLevelDetail",
  components: {LevelForm},
  data() {
    return {
      detailInfo: {}
    }
  },
  methods: {
    // 加载详情
    async loadDetail() {
      try {
        const res = await request(this.$api.vipLevel.detail, this.$route.query);
        this.detailInfo = res.vipLevel;
      } catch (e) {
        console.log(e);
      }
    }
  },
  created() {
    this.loadDetail();
  }
}
</script>

<style scoped>

</style>
